function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import classNames from 'classnames';
import Icon from '../icon/Icon';
import PaymentIcon from '../paymentIcon/PaymentIcon';
import { ICON_TYPE_PROP_TYPE, ICON_SIZE_PROP_TYPE, COLOR_PROP_TYPE } from '../icon/constants';
import { PAYMENT_TYPE_PROP_TYPE, PAYMENT_SIZE_PROP_TYPE } from '../paymentIcon/constants';
import { VERTICAL_ALIGNMENTS_PROP_TYPE } from './constants';
import { VECTOR_IMAGE_PAYMENT } from '../vectorImage/constants';
import { getIconVectorType } from '../icon/util';

var ExtraContent = function ExtraContent(_ref) {
  var children = _ref.children;
  var component = null;

  if (children) {
    component = React.createElement("div", {
      className: "eds-list-item__aside eds-list-item__extra-content eds-l-pad-right-4",
      "data-spec": "list-item-extra-content"
    }, children);
  }

  return component;
};

var ItemIcon = function ItemIcon(_ref2) {
  var _classNames;

  var iconType = _ref2.iconType,
      iconSize = _ref2.iconSize,
      iconColor = _ref2.iconColor,
      iconStrokeColor = _ref2.iconStrokeColor,
      children = _ref2.children,
      extraContent = _ref2.extraContent,
      isSelected = _ref2.isSelected,
      isTentativelySelected = _ref2.isTentativelySelected,
      useAltTheme = _ref2.useAltTheme,
      isDisabled = _ref2.isDisabled,
      verticalAlignment = _ref2.verticalAlignment,
      displayInline = _ref2.displayInline;
  var className = classNames('eds-list-item', (_classNames = {
    'eds-list-item--selected': isSelected,
    'eds-list-item--tentatively-selected': isTentativelySelected,
    'eds-list-item--alt-theme': useAltTheme,
    'eds-list-item--disabled': isDisabled
  }, _defineProperty(_classNames, "eds-list-item--align-".concat(verticalAlignment), verticalAlignment), _defineProperty(_classNames, 'eds-list-item--display-inline', displayInline), _classNames));
  var icon = React.createElement(Icon, {
    type: iconType,
    size: iconSize,
    color: iconColor,
    strokeColor: iconStrokeColor
  });

  if (getIconVectorType(iconType) === VECTOR_IMAGE_PAYMENT) {
    icon = React.createElement(PaymentIcon, {
      type: iconType,
      size: iconSize
    });
  }

  return React.createElement("div", {
    className: className,
    "data-spec": "eds-list-item"
  }, React.createElement(ExtraContent, null, extraContent), React.createElement("span", {
    className: "eds-list-item__aside eds-list-item__icon"
  }, icon), children);
};

var ItemImage = function ItemImage(_ref3) {
  var imageUrl = _ref3.imageUrl,
      imageAlt = _ref3.imageAlt,
      isSquareImage = _ref3.isSquareImage,
      children = _ref3.children,
      extraContent = _ref3.extraContent,
      verticalAlignment = _ref3.verticalAlignment;
  var className = classNames('eds-list-item', _defineProperty({}, "eds-list-item--align-".concat(verticalAlignment), verticalAlignment));
  var classNameGraphic = classNames('eds-list-item__aside', 'eds-list-item__graphic', {
    'eds-list-item__graphic--square': isSquareImage
  });
  return React.createElement("div", {
    className: className,
    "data-spec": "eds-list-item"
  }, React.createElement(ExtraContent, null, extraContent), React.createElement("span", {
    className: classNameGraphic,
    "data-spec": "list-item-graphic"
  }, React.createElement("img", {
    src: imageUrl,
    alt: imageAlt,
    "data-spec": "list-item-graphic-image"
  })), children);
};

var ListItem =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ListItem, _PureComponent);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(ListItem).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          iconType = _this$props.iconType,
          iconTypes = _this$props.iconTypes,
          iconSize = _this$props.iconSize,
          iconColor = _this$props.iconColor,
          iconStrokeColor = _this$props.iconStrokeColor,
          imageUrl = _this$props.imageUrl,
          imageAlt = _this$props.imageAlt,
          isSquareImage = _this$props.isSquareImage,
          children = _this$props.children,
          extraContent = _this$props.extraContent,
          isTentativelySelected = _this$props.isTentativelySelected,
          isSelected = _this$props.isSelected,
          useAltTheme = _this$props.useAltTheme,
          isDisabled = _this$props.isDisabled,
          showStatus = _this$props.showStatus,
          statusText = _this$props.statusText,
          verticalAlignment = _this$props.verticalAlignment;
      var itemIconProps = {
        iconType: iconType,
        iconSize: iconSize,
        iconColor: iconColor,
        iconStrokeColor: iconStrokeColor,
        isSelected: isSelected,
        isTentativelySelected: isTentativelySelected,
        useAltTheme: useAltTheme,
        isDisabled: isDisabled,
        verticalAlignment: verticalAlignment
      };
      var statusTextFormatted;

      if (showStatus) {
        statusTextFormatted = React.createElement("div", {
          className: "eds-list-item__status"
        }, React.createElement("span", {
          className: "eds-l-pad-hor-1"
        }, "\xB7"), React.createElement("span", {
          className: "eds-text-bs"
        }, statusText));
      }

      var component = React.createElement("div", {
        className: "eds-list-item__contents",
        "data-spec": "eds-list-item-contents"
      }, children, statusTextFormatted);

      if (iconTypes) {
        var iconContent = null;
        var lastIconExtraContent = null;
        var itemIcons = iconTypes.map(function (icon) {
          if (icon === iconTypes[iconTypes.length - 1]) {
            iconContent = React.createElement("div", {
              className: "eds-list-item__contents eds-list-item--display-inline",
              key: "list-item-contents",
              "data-spec": "eds-list-item-contents"
            }, children);
            lastIconExtraContent = extraContent;
          }

          return React.createElement(ItemIcon, _extends({
            key: icon.type.displayName
          }, itemIconProps, {
            iconType: icon,
            extraContent: lastIconExtraContent,
            displayInline: true
          }));
        });
        itemIcons.push(iconContent);
        component = React.createElement("div", {
          "data-spec": "eds-list-items-wrapper"
        }, itemIcons);
      } else if (iconType) {
        component = React.createElement(ItemIcon, _extends({}, itemIconProps, {
          extraContent: extraContent
        }), component);
      } else if (imageUrl) {
        component = React.createElement(ItemImage, {
          imageUrl: imageUrl,
          imageAlt: imageAlt,
          isSquareImage: isSquareImage,
          verticalAlignment: verticalAlignment,
          extraContent: extraContent
        }, component);
      } else {
        var className = classNames('eds-list-item', _defineProperty({}, "eds-list-item--align-".concat(verticalAlignment), verticalAlignment));
        component = React.createElement("div", {
          className: className,
          "data-spec": "eds-list-item"
        }, React.createElement(ExtraContent, null, extraContent), component);
      }

      return component;
    }
  }]);

  return ListItem;
}(PureComponent);

_defineProperty(ListItem, "propTypes", {
  /**
   * Contents of icon list item
   */
  children: PropTypes.node.isRequired,

  /**
   * Generic content for the left side
   */
  extraContent: PropTypes.node,

  /**
   * Icon to include in the list item that when specified will wrap the `children` to include the icon
   * Will not be used if iconTypes is specified
   */
  iconType: PropTypes.oneOfType([ICON_TYPE_PROP_TYPE, PAYMENT_TYPE_PROP_TYPE]),

  /**
   * Icons to include in the list item that when specified will wrap the `children` to include the icons
   */
  iconTypes: PropTypes.arrayOf(PropTypes.oneOfType([ICON_TYPE_PROP_TYPE, PAYMENT_TYPE_PROP_TYPE])),

  /**
   * Size of included icon
   */
  iconSize: PropTypes.oneOfType([ICON_SIZE_PROP_TYPE, PAYMENT_SIZE_PROP_TYPE]),

  /**
   * Color of included icon
   */
  iconColor: COLOR_PROP_TYPE,

  /**
   * Color of included stroke
   */
  iconStrokeColor: COLOR_PROP_TYPE,

  /**
   * Vertical alignment of children items
   */
  verticalAlignment: VERTICAL_ALIGNMENTS_PROP_TYPE,

  /**
   * URL of image to be displayed with list item content
   */
  imageUrl: PropTypes.string,

  /**
   * Alt text for image to be displayed with list item content
   */
  imageAlt: EBPropTypes.translation,

  /**
   * Optional square shape image - note you must pass in an imageUrl
   * for an image that is either 1:1 or wider than it is tall.
   */
  isSquareImage: PropTypes.bool,

  /**
   * Whether or not the list item is selected
   */
  isSelected: PropTypes.bool,

  /**
   * Whether or not the text list item is tenatively selected.
   * This comes into play on hover or via arrow key press before an
   * actual selection is made
   */
  isTentativelySelected: PropTypes.bool,

  /**
   * Whether or not the item should use an alternate theme
   */
  useAltTheme: PropTypes.bool,

  /**
   * Whether or not the item is disabled
   */
  isDisabled: PropTypes.bool,

  /**
   * Whether to show a status next to the list item
   * For example, show 'NEW' next to the 'Widgets' link
   * when a new widget is available (EB-61595)
   */
  showStatus: PropTypes.bool,

  /**
   * Text that should be displayed in the status
   */
  statusText: EBPropTypes.translation
});

_defineProperty(ListItem, "defaultProps", {
  iconSize: 'small',
  verticalAlignment: 'middle',
  isSelected: false,
  useAltTheme: false,
  isDisabled: false,
  showStatus: false,
  statusText: '',
  isSquareImage: false
});

export { ListItem as default };